import { render, staticRenderFns } from "./orderLogistics.vue?vue&type=template&id=426ad952&scoped=true&"
import script from "./orderLogistics.vue?vue&type=script&lang=js&"
export * from "./orderLogistics.vue?vue&type=script&lang=js&"
import style0 from "./orderLogistics.vue?vue&type=style&index=0&id=426ad952&lang=scss&scoped=true&"
import style1 from "./orderLogistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ad952",
  null
  
)

export default component.exports